import { v1_hot_tag_autoTrackMenu_post_ } from 'server/apis/4285.js'
export const trackmMenuRank = function(data) {
  const vuex = JSON.parse(localStorage.getItem('vuex'))
  const dingTalkUserId = vuex.user.userInfo.dingTalkUserId
  // let json = menuRank ? JSON.parse(menuRank) : []
  const { systemId, menuName, menuPath, id, systemName } = data
  if (systemName !== '统一网站') {
    v1_hot_tag_autoTrackMenu_post_({
      tagName: menuName,
      tagURL: menuPath,
      systemName,
      systemId: +systemId,
      count: 1,
      userId: dingTalkUserId,
      type: 1 // 默认点击系统菜单
    })
  }
}

// 保存点击的菜单数据
// const saveTrackMenu = (json, data) => {
//   if (!data) {
//     return json
//   }
//   const { systemId, menuName, menuPath, id, systemName } = data
//   if (systemName !== '统一网站') {
//     const index = json.findIndex(item => {
//       return item.id === id && item.systemId === systemId
//     })

//     if (index > -1) {
//       json[index].count++
//     } else if (id > -1) {
//       json.push({
//         menuName,
//         menuPath,
//         systemName,
//         id,
//         systemId,
//         count: 1,
//         type: 1 // 默认点击系统菜单
//       })
//     }
//   }
//   return json
// }
